import {
  actions as dataFetchActions,
  actionTypes as dataFetchActionTypes,
} from '@bufferapp/async-data-fetch';
import { actionTypes as orgActionTypes } from '~/organizations';
import { actions as notificationActions } from '@bufferapp/notifications';

export default ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    switch (action.type) {
      case orgActionTypes.ORGANIZATION_SELECTED: {
        const { id, hasCampaignsFeature } = action.selected;
        if (hasCampaignsFeature) {
          dispatch(
            dataFetchActions.fetch({
              name: 'getCampaignsList',
              args: { id },
            })
          );
        }
        break;
      }

      case `getCampaignsList_${dataFetchActionTypes.FETCH_FAIL}`:
        dispatch(
          notificationActions.createNotification({
            notificationType: 'error',
            message: action.error,
          })
        );
        break;

      default:
        break;
    }
  };
